import Container from '@brands/Components/Container/Container';
import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import { useWindowSize } from '@brands/hooks';
import { customStylesDashboard } from '@brands/Utils/customStyles';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { isValidEmail } from '@brands/Utils/validation';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { AiOutlineClose } from 'react-icons/ai';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import Modal from 'react-modal';
import * as Yup from 'yup';

import styles from './styles.module.scss';

interface ChangeEmailModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (email: string) => void;
  email: string;
}

interface ChangeEmailForm {
  email: string;
}

const ChangeEmailModal: FC<ChangeEmailModalProps> = ({ isOpen, onClose, onSubmit, email }) => {
  const isMobile = useWindowSize().width < 768;

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Email is required')
      .test('test-name', 'Enter Valid Email', (value) => {
        if (!isValidEmail(value as string)) {
          return false;
        }
        return true;
      }),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm<ChangeEmailForm>({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
  });

  if (isMobile) {
    return (
      <Container
        patientDashboard
        isSidenavVisible
        childClassName={styles.changeEmailDashboard}
        containerStyle={{
          justifyContent: 'start',
          overflowY: 'scroll',
          zIndex: zIndex.drawer + 1,
        }}
      >
        <div className={styles.changeEmailDashboardContainer}>
          <div className={styles.changeEmailCard}>
            <button type="button" className={styles.backButton} onClick={onClose} aria-label="Back">
              <MdKeyboardArrowLeft />
              Back
            </button>
            <div className={styles.changeEmailContainer}>
              <p className={`fs-unmask ${styles.title}`}>Update email address</p>
              <form
                className={`fs-unmask ${styles.formContainer}`}
                onSubmit={handleSubmit((data) => {
                  const emailValue = data.email;
                  if (!emailValue) {
                    displayErrorDetails('Email is required');
                    return;
                  }
                  if (!isValidEmail(emailValue)) {
                    displayErrorDetails('Enter Valid Email');
                    return;
                  }
                  onSubmit(emailValue);
                })}
              >
                <div className={styles.inputWrap}>
                  <div className={styles.inputWrapper}>
                    <TextField
                      {...register('email')}
                      label="New email address"
                      type="email"
                      errors={errors.email && errors.email.message !== 'Check your email' ? errors : {}}
                      name="email"
                      onChange={(e) => {
                        setValue('email', e.target.value);
                      }}
                      autoComplete="new-email"
                      inputClass={`${styles.profileInputClass} fs-exclude`}
                      wrapperClassName={`${styles.createAccountClass}`}
                    />
                  </div>
                </div>
                <div className={styles.buttonContainer}>
                  <div className={styles.buttonWrapper}>
                    <Button type="submit" disabled={!email} className={`fs-unmask ${styles.formBtn}`}>
                      Update Email Address
                    </Button>
                  </div>
                  <Button type="button" className={`fs-unmask ${styles.formCancelBtn}`} onClick={onClose}>
                    Cancel
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Container>
    );
  }
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStylesDashboard}
      contentLabel="Modal"
      ariaHideApp={false}
    >
      <div className={styles.changeEmailCard}>
        <button
          type="button"
          className={`fs-unmask ${styles.modalClose}`}
          data-micromodal-close=""
          onClick={onClose}
          aria-label="Close modal"
        >
          <AiOutlineClose className={styles.icon} />
        </button>
        <button type="button" className={styles.backButton} onClick={onClose} aria-label="Back">
          <MdKeyboardArrowLeft />
          Back
        </button>
        <div className={styles.changeEmailContainer}>
          <p className={`fs-unmask ${styles.title}`}>Update email address</p>
          <form
            className={styles.formContainer}
            onSubmit={handleSubmit((data) => {
              const emailValue = data.email;
              if (!emailValue) {
                displayErrorDetails('Email is required');
                return;
              }
              if (!isValidEmail(emailValue)) {
                displayErrorDetails('Enter Valid Email');
                return;
              }
              onSubmit(emailValue);
            })}
          >
            <div className={styles.inputWrap}>
              <div className={styles.inputWrapper}>
                <TextField
                  {...register('email')}
                  label="New email address"
                  type="email"
                  errors={errors.email && errors.email.message !== 'Check your email' ? errors : {}}
                  name="email"
                  onChange={(e) => {
                    setValue('email', e.target.value);
                  }}
                  autoComplete="new-email"
                  inputClass={`${styles.profileInputClass} fs-exclude`}
                  wrapperClassName={`fs-unmask ${styles.createAccountClass}`}
                />
              </div>
            </div>
            <div className={styles.buttonContainer}>
              <div className={styles.buttonWrapper}>
                <Button type="submit" disabled={!email} className={`fs-unmask ${styles.formBtn}`}>
                  Update Email Address
                </Button>
              </div>
              <Button type="button" className={`fs-unmask ${styles.formCancelBtn}`} onClick={onClose}>
                Cancel
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default ChangeEmailModal;
